module.exports = __webpack_public_path__ + "static/media/shift_actions1.58818077.png";